import type { ComponentProps } from "react";

import { SvgSlot } from "@/shared/ui";

const FULL_LAST_STAR = (
  <>
    <path d="M127.987 0H104V23.9872H127.987V0Z" fill="#00B67A" />
    <path
      d="M119.644 14.793L115.996 15.7174L121.168 19.4904L119.644 14.793Z"
      fill="white"
    />
    <path
      d="M117.969 9.64834H124.391L119.218 13.3963L116.02 15.6952L110.823 19.4431L112.797 13.3963L107.6 9.64834H114.021L115.995 3.60156L117.969 9.64834Z"
      fill="white"
    />
  </>
);

const PARTIAL_LAST_STAR = (
  <>
    <path d="M128 0H104V24H128V0Z" fill="white" />
    <path d="M128 0H104V24H128V0Z" fill="#00B67A" />
    <path d="M128 0H124V24H128V0Z" fill="#E5E5E5" />
    <path
      d="M120.056 15.8164L116 16.9024L121.75 21.3343L120.056 15.8164Z"
      fill="white"
    />
    <path
      d="M118.194 9.77069H125.333L119.583 14.1732L116.027 16.8734L110.249 21.276L112.444 14.1732L106.666 9.77069H113.805L115.999 2.66797L118.194 9.77069Z"
      fill="white"
    />
  </>
);

type TrustpilotStarsProps = ComponentProps<typeof SvgSlot> & {
  full?: boolean;
};

export const TrustpilotStars = ({
  full = true,
  ...props
}: TrustpilotStarsProps) => (
  <SvgSlot {...props}>
    <svg viewBox="0 0 128 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.9872 0H0V23.9872H23.9872V0Z" fill="#00B67A" />
      <path
        d="M15.6441 14.793L11.9961 15.7174L17.1684 19.4904L15.6441 14.793Z"
        fill="white"
      />
      <path
        d="M13.969 9.64834H20.3906L15.2184 13.3963L12.0201 15.6952L6.82289 19.4431L8.79683 13.3963L3.59961 9.64834H10.0212L11.9951 3.60156L13.969 9.64834Z"
        fill="white"
      />
      <path d="M49.9872 0H26V23.9872H49.9872V0Z" fill="#00B67A" />
      <path
        d="M41.6441 14.793L37.9961 15.7174L43.1684 19.4904L41.6441 14.793Z"
        fill="white"
      />
      <path
        d="M39.969 9.64834H46.3906L41.2184 13.3963L38.0201 15.6952L32.8229 19.4431L34.7968 13.3963L29.5996 9.64834H36.0212L37.9951 3.60156L39.969 9.64834Z"
        fill="white"
      />
      <path d="M75.9872 0H52V23.9872H75.9872V0Z" fill="#00B67A" />
      <path
        d="M67.6441 14.793L63.9961 15.7174L69.1684 19.4904L67.6441 14.793Z"
        fill="white"
      />
      <path
        d="M65.969 9.64834H72.3906L67.2184 13.3963L64.0201 15.6952L58.8229 19.4431L60.7968 13.3963L55.5996 9.64834H62.0212L63.9951 3.60156L65.969 9.64834Z"
        fill="white"
      />
      <path d="M101.987 0H78V23.9872H101.987V0Z" fill="#00B67A" />
      <path
        d="M93.6441 14.793L89.9961 15.7174L95.1684 19.4904L93.6441 14.793Z"
        fill="white"
      />
      <path
        d="M91.969 9.64834H98.3906L93.2184 13.3963L90.0201 15.6952L84.8229 19.4431L86.7968 13.3963L81.5996 9.64834H88.0212L89.9951 3.60156L91.969 9.64834Z"
        fill="white"
      />
      {full ? FULL_LAST_STAR : PARTIAL_LAST_STAR}
    </svg>
  </SvgSlot>
);
